var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React, { useEffect, useImperativeHandle, useState } from "react";
import styled, { keyframes } from "styled-components";
import { Paper } from "@material-ui/core";
var ContainerBox = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  bottom: 0;\n  min-height: 100px;\n  box-shadow: -2px 3px 2px 1px rgba(0, 0, 0, 0.2),\n    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);\n"], ["\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  bottom: 0;\n  min-height: 100px;\n  box-shadow: -2px 3px 2px 1px rgba(0, 0, 0, 0.2),\n    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);\n"])));
var show = function show(animateHeight) {
  return keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    from {\n      transform: translateY(", ");\n    }\n\n    to  {\n      transform: translateY(0px);\n    }\n  }\n"], ["\n    from {\n      transform: translateY(", ");\n    }\n\n    to  {\n      transform: translateY(0px);\n    }\n  }\n"])), animateHeight && animateHeight !== "auto" ? animateHeight : "225px");
};
var hide = function hide(animateHeight) {
  return keyframes(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  from {\n    transform: translateY(0px);\n  }\n\n  to {\n    transform: translateY(", ");\n  }\n"], ["\n  from {\n    transform: translateY(0px);\n  }\n\n  to {\n    transform: translateY(", ");\n  }\n"])), animateHeight && animateHeight !== "auto" ? animateHeight : "225px");
};
var AnimatedOutputBox = styled(Paper)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  animation: ", "\n    0.2s ease-in-out;\n  border: 4px 4px 0px 0px;\n  position: relative;\n  width: 100%;\n"], ["\n  animation: ", "\n    0.2s ease-in-out;\n  border: 4px 4px 0px 0px;\n  position: relative;\n  width: 100%;\n"])), function (props) {
  return props.open ? show(props.animatefrom) : hide(props.animatefrom);
});
var Output = React.forwardRef(function (props, ref) {
  var _a = useState(false),
    open = _a[0],
    setOpen = _a[1];
  var _b = useState(false),
    render = _b[0],
    setRender = _b[1];
  var isRunning = props.isRunning,
    outputHeight = props.outputHeight;
  var close = function close() {
    setOpen(false);
  };
  var openFn = function openFn() {
    setOpen(true);
    setRender(true);
  };
  useEffect(function () {
    if (isRunning && !render) {
      setRender(true);
      if (!open) setOpen(true);
    }
  }, [isRunning]);
  useImperativeHandle(ref, function () {
    return {
      close: close,
      open: openFn
    };
  });
  var onAnimationEnd = function onAnimationEnd() {
    if (!open) {
      setRender(false);
    }
  };
  if (!render) return null;
  return React.createElement(ContainerBox, {
    "data-cy": "output-container"
  }, React.createElement(AnimatedOutputBox, {
    animatefrom: outputHeight,
    open: open,
    onAnimationEnd: onAnimationEnd
  }, props.children));
});
export default Output;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;